import { z } from "zod";

import { Industry } from "Infrastructure/Api/Api";
import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

const exclusiveContractSchema = z.object({
  actorID: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  price: z
    .number({ error: () => getTranslation(Resources.Validation.Required) })
    .min(0, { error: () => getTranslation(Resources.Validation.Number.Min) }),
  jobLimit: z
    .number({ error: () => getTranslation(Resources.Validation.Required) })
    .int()
    .min(1, { error: () => getTranslation(Resources.Validation.Number.Min) }),
});

export const createProjectFormSchema = z
  .object({
    name: z
      .string()
      .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
    clientID: z
      .string()
      .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
    moduleID: z
      .string()
      .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
    industry: z.enum(Industry),
    language: z
      .string()
      .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
    licensedCountries: z
      .array(z.string())
      .min(1, { error: () => getTranslation(Resources.Validation.Array.Min) }),
    jobsLimit: z.number().min(0, {
      error: () => getTranslation(Resources.Validation.Number.Min),
    }),
    startDate: z.date().nullable().optional(),
    endDate: z.date().nullable().optional(),
    hasExclusiveContracts: z.boolean(),
    exclusiveContracts: z.array(exclusiveContractSchema),
  })
  .superRefine((data, ctx) => {
    if (data.startDate && data.endDate && data.endDate < data.startDate) {
      ctx.addIssue({
        code: "custom",
        message: getTranslation(Resources.Validation.Date.MustBeAfterStartDate),
        path: ["endDate"],
      });
    }
    if (data.hasExclusiveContracts && data.exclusiveContracts.length === 0) {
      ctx.addIssue({
        code: "custom",
        message: getTranslation(Resources.Validation.Array.Min),
        path: ["exclusiveContracts"],
      });
    }
  });

export type CreateProjectFormData = z.infer<typeof createProjectFormSchema>;
